<template>
 <base-dialog :showDialog="showDialog">
    <template v-slot:body>
        <v-card dark>
            <v-card-title>
                <span class="text-h5">{{$t('titulos.contatarWpp')}}</span>
            </v-card-title>
            <v-card-text>
                <span class="text-overline">{{$t('dialogs.contatarWpp',{numeroCelular: numeroCelular})}}</span>
                <v-text-field v-model="numeroWhatsapp"  placeholder="5545911223344" outlined></v-text-field>
            </v-card-text>
        <v-card-actions>
            <v-btn color="info"
                @click="$emit('close')" class="text-overline">
                {{$t('labels.voltar')}}
            </v-btn>
            <v-spacer></v-spacer>
            <v-btn color="success" class="text-overline" @click="contatarWhatsapp()">
                <v-icon>mdi-whatsapp</v-icon>
                <span>{{$t('labels.contatar')}}</span>
            </v-btn>
        </v-card-actions>            
        </v-card>

    </template>
 </base-dialog>
</template>

<script>
import BaseDialog from '@/components/shared/base-dialog/BaseDialog.vue'
export default {
    data: () => {
        return {
            numeroWhatsapp: ''
        }
    },
    components: {BaseDialog},
    methods:{
        contatarWhatsapp(){
            if(this.numeroWhatsapp.length > 0)
            {
                let url = `https://api.whatsapp.com/send/?phone=${this.numeroWhatsapp}`
                window.open(url, '_blank').focus()
            }
            
        },
        setNumber(){
            this.numeroWhatsapp = this.numeroCelular
        }
    },
    mounted() {
        this.setNumber()
    },
    props:{
        showDialog:{
            type: Boolean,
            required:true
        },
        numeroCelular:{
            type: String,
            required:true
        }
    }
}
</script>